import * as React from "react";
import { hot } from "react-hot-loader";


class CustomLoader extends React.Component<{}, {}> {

  constructor(props: any) {
    super(props);
    
  }

  public render() {

    return (
      <div className="customLoader" />
    );
  }
}

export default hot(module)(CustomLoader);
